/**
 * Which picture a puzzle board hides.
 *
 * The built-in scenes are drawn in code by the web app; this module only knows
 * their names, so the server can choose a round's picture without knowing how
 * any of them look.
 */

export const BUILTIN_SCENES = ['rocket', 'cat', 'boat', 'tree', 'whale', 'balloon'] as const;
export type BuiltinScene = (typeof BUILTIN_SCENES)[number];

export const isBuiltinScene = (v: string): v is BuiltinScene =>
  (BUILTIN_SCENES as readonly string[]).includes(v);

/**
 * The pool "surprise me" draws from: every built-in scene, then the teacher's
 * own pictures. Built-ins come first so that a seed keeps naming the same
 * built-in scene however many pictures are uploaded later.
 */
export const picturePool = (uploads: readonly string[]): string[] =>
  [...BUILTIN_SCENES, ...uploads.filter((id) => id && !isBuiltinScene(id))];

/**
 * The picture for one board: the level's own choice when it made one, and
 * otherwise one from the pool, chosen by the deal seed — so every player in a
 * round, dealt from the same seed, sees the same picture.
 */
export function pickPicture(scene: string, seed: number, pool: readonly string[]): string {
  if (scene) return scene;
  const all = pool.length ? pool : BUILTIN_SCENES;
  return all[Math.abs(Math.trunc(seed)) % all.length]!;
}
